import { DIRows, DONormalRows, AIRows, ThermalKRows, OutputRows, DORelayRows } from './sensor-cable-tag-print';

export class Slot {
    id: string;
    fcuId: string;
    fuId: string | null;
    vesselId: string;
    ioType: SlotOptionType;
    no: number;
    terminal: Terminal[];
    enable: boolean;
}

export const terminalType = {
    normal: 'Normal',
    relay: 'Relay',
} as const;

export type TerminalType = (typeof terminalType)[keyof typeof terminalType];

export const DORelayTypeOptions = {
    relay: 'Relay',
    relayCommonCom: 'Relay (Common COM)',
    relayAc220v: 'Relay (for AC220V)',
    relayAc220vCommonCom: 'Relay (for AC220V - Common COM)',
} as const;

export type DoRelayType = (typeof DORelayTypeOptions)[keyof typeof DORelayTypeOptions];

export enum TerminalSide {
    UNDEFINED = 'undefined',
    RIGHT = 'right',
    LEFT = 'left',
}

export type Terminal = {
    index: number;
    num: number;
    type: TerminalType;
    side: TerminalSide;
    doRelayType?: DoRelayType;
};

export const emptySlot = 'Empty slot';
export const emptyValue = 'Empty';

export const normalPinNum = 32;
export const relayPinNum = 16;
export const doubleRelayPinNum = 32;

export const slotOptions = [
    emptySlot,
    'DI',
    'DO',
    'AI (4-20mA)',
    'AI (Pt100 2-wire)',
    'AI (Pt100 3-wire)',
    'AI (Thermal K)',
    'AI (1-5V)',
    'AO (4-20mA)',
] as const;

export type SlotOptionType = (typeof slotOptions)[number] | typeof emptyValue | '';

export enum BoardType {
    UNDEFINED = 'undefined',
    M002 = 'M002',
    M003 = 'M003',
    M400 = 'M400',
    M500 = 'M500',
    M110 = 'M110',
    M030 = 'M030',
    M200 = 'M200',
}

export const slotMax = 8;

export function getFcuDefaultSlots(vesselId: string) {
    const fcuSlots = 8;

    const defaultSlotTemplate = {
        id: '',
        fcuId: '',
        fuId: null,
        vesselId: vesselId,
        ioType: '',
        enable: true,
        terminal: [],
    } as Slot;

    const defaultSlotList: Slot[] = Array.from({ length: fcuSlots }, (_, i) => ({
        ...defaultSlotTemplate,
        no: i + 1,
    }));

    return defaultSlotList;
}

export function getSlotPinNum(slotType: SlotOptionType, terminals: Terminal[]) {
    if (slotType == 'DI') {
        return DIRows;
    } else if (slotType == 'DO') {
        let numPins = 0;
        if (!terminals || terminals.length == 0) return numPins;
        for (let i = 0; i < terminals.length; i++) {
            const terminal = terminals[i];
            if (terminal.type == terminalType.normal) numPins += DONormalRows;
            else if (terminal.type == terminalType.relay) numPins += DORelayRows;
        }
        return numPins;
    } else if (
        slotType == 'AI (4-20mA)' ||
        slotType == 'AI (Pt100 2-wire)' ||
        slotType == 'AI (1-5V)' ||
        slotType == 'AI (Pt100 3-wire)'
    ) {
        return AIRows;
    } else if (slotType == 'AI (Thermal K)') {
        return ThermalKRows;
    } else if (slotType == 'AO (4-20mA)') {
        return OutputRows;
    }
}

export function isDigitalSlot(slotType: SlotOptionType): boolean {
    if (slotType == 'DI' || slotType == 'DO') return true;
    return false;
}
